import type { PAGE_POSITIONS } from 'types';

import gtm from '~/services/gtm.client';

import UserEvent from './UserEvent';

type EventData = {
  isBot: boolean;
  product_name: string;
  search_term: string;
};

class SearchResultClickEvent extends UserEvent<EventData> {
  sendToGtm() {
    if (this.data.isBot) return;

    const page_position: PAGE_POSITIONS = 'Header';

    gtm.pushToDataLayer({
      event: 'search_result_click',
      page_position,
      product_name: this.data.product_name,
      search_term: this.data.search_term
    });
  }
}

export default SearchResultClickEvent;
